import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { CATEGORY_FILTER_OVERLAY_ID } from 'Component/CategoryFilterOverlay/CategoryFilterOverlay.config';
import { urlStringToObject } from 'Util/Url';

/** @namespace Bodypwa/Hooks/UseCategoryFilterOverlayProps/useCategoryFilterOverlayProps */
export const useCategoryFilterOverlayProps = () => {
    const filters = useSelector((state) => state.ProductListInfoReducer.filters);
    const isProductsLoading = useSelector((state) => state.ProductListReducer.isLoading);
    const totalPages = useSelector((state) => state.ProductListReducer.totalPages);
    const suffix = useSelector((state) => state.ConfigReducer.category_url_suffix || '.html');
    const seoFilterParams = useSelector((state) => state.UrlRewritesReducer.urlRewrite.params);
    const filter_key = useSelector((state) => state.ConfigReducer.filter_key);
    const isMobile = useSelector((state) => state.ConfigReducer.device.isMobile);
    const categoryId = useSelector((state) => state.ProductListReducer.id);
    const category = useSelector((state) => state.CategoryReducer?.category || null);
    const selectedInfoFilter = useSelector((state) => state.ProductListInfoReducer.selectedFilter);
    const totalItems = useSelector((state) => state.ProductListReducer.totalItems);
    const isClosed = useSelector((state) => state.OverlayReducer.activeOverlay !== CATEGORY_FILTER_OVERLAY_ID);
    const location = useLocation();

    const getAreFiltersEmpty = () => !filters || !Object.keys(filters).length;

    const isContentFiltered = () => {
        const { customFilters, priceMin, priceMax } = urlStringToObject(location.search);
        return !!(customFilters || priceMin || priceMax);
    };

    return {
        filters,
        isProductsLoading,
        totalPages,
        suffix,
        seoFilterParams,
        filter_key,
        isMobile,
        isContentFiltered: isContentFiltered(),
        areFiltersEmpty: getAreFiltersEmpty(),
        isCategoryAnchor: !!category?.isAnchor || false,
        isSearchPage: !!category?.id || true,
        selectedInfoFilter,
        totalItems,
        categoryId,
        isClosed
    };
};
